module.exports = __webpack_public_path__ + "static/img/yusurika_ka.eeacae5.jpg";